/* global CANNY_APP_ID */
import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { HelpMenu as NavHelpMenu } from '@studio/navigation';

import { selectAccount } from 'next/entities/account';
import { CANNY, selectFeature } from 'next/entities/features';
import { selectUser } from 'next/entities/user';
import { history } from 'next/lib/history';

const HelpMenu = unhandledProps => {
  const [location, setLocation] = useState();

  useEffect(() => {
    return history.listen(({ key }) => {
      setLocation(key);
    });
  }, []);

  return <NavHelpMenu {...unhandledProps} location={location} />;
};

const mapStateToProps = state => ({
  account: selectAccount(state),
  hasCannyEnabled: selectFeature(state, CANNY),
  user: selectUser(state),
  cannyAppId: CANNY_APP_ID,
});

export default connect(mapStateToProps)(HelpMenu);
